import * as React from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthProvider, useNotify } from 'react-admin';
import { SongtekAuthProvider } from './authProvider';
import { HELLO_URL } from '../serviceUrls';

const PUBLIC_URL = (new URL('/login/', document.location.href)).href;// 'http://localhost:3000/login/';
const LOGIN_URL = HELLO_URL + '/auth/?redirectToPath=/Goto/' + btoa(PUBLIC_URL);
let lastOTP = '';
const MyLoginPage: React.FC = () => {
    const authProvider = useAuthProvider<SongtekAuthProvider>();
    const notify = useNotify();
    const navigate = useNavigate();
    const { searchParams } = new URL(window.location.href);
    const otp = searchParams.get('otp');
    useEffect(() => {
        if (!otp || lastOTP === otp || !authProvider)
            return;
        lastOTP = otp;
        authProvider.login({ otp })
            .then(({ redirectTo }: { redirectTo: string }) => {
                navigate(redirectTo || '/', { replace: true });
            })
            .catch((e: Error) => {
                notify(e.message);
                window.location.href = LOGIN_URL;
            });
    }, []);
    if (!otp) {
        window.location.href = LOGIN_URL;
        return <p>Redirecting ... </p>;
    }
    return (
        <p>Authenticating ... </p>
    );
};

export default MyLoginPage;
